<template>
  <div>
    <div id="admin-preloader" v-if="loading">
      <div id="admin-loader-text">Loading</div>
      <div id="admin-loader"></div>
    </div>
    <div id="admin-preloader" v-if="loading1">
      <div id="admin-loader-text">Updating</div>
      <div id="admin-loader"></div>
    </div>
    <div id="admin-preloader" v-if="loading2">
      <div id="admin-loader-text">Deleting</div>
      <div id="admin-loader"></div>
    </div>

    <div class="" v-if="changed">
      <div v-if="$store.state.systemUser.role !== 'Kitchen Staff'" class="m-auto text-right pt-3">
        <el-button
          @click="dialogFormVisible2 = true"
          type="primary"
          size="medium"
        >
          <i class="el-icon-plus mr-2"></i>{{$route.name === 'jobNotes' ? 'Add Job' : 'Add Order'}}</el-button
        >
      </div>

      <div class="col-sm-12 col-md-8 col-lg-6 m-auto pl-4">
        <el-dialog
          :title="$route.name === 'jobNotes' ? 'Add job' : 'Add order'"
          :visible.sync="dialogFormVisible2"
          :width="width"
        >
          <!-- <h4 class="text-center pt-4 pb-3">Add Expense</h4> -->
          <el-card shadow="always" style="background-color: #f5f7fa">
            <JobNoteDialog :jobItemData="jobItems" :method="'create'" :users="users" :allProducts="allProducts" />
          </el-card>
        </el-dialog>
        <el-dialog
          :title="$route.name === 'jobNotes' ? 'Update job' : 'Update order'"
          :visible.sync="dialogFormVisible"
          @close="BUS.$emit('dialogClosed')"
          @open="BUS.$emit('dialogOpen', job)"
          :width="width"
        >
          <!-- <h4 class="text-center pt-4 pb-3">Add Expense</h4> -->
          <el-card shadow="always" style="background-color: #f5f7fa">
            <JobNoteDialog :jobItemData="job.items" :method="'update'" :users="users" :jobData="job" :jobid="job.id" :allProducts="allProducts" />
          </el-card>
        </el-dialog>
      </div>

      <b-container class="col-lg-10 mt-5">
        <h3 v-if="$route.name === 'jobNotes'" class="text-info text-center pt-4 my-4">Job Notes</h3>
        <h3 v-if="$route.name === 'orderProcessing'" class="text-info text-center pt-4 my-4">Order Processing</h3>
        <!-- User Interface controls -->

         <el-card
          shadow="always"
          style="background-color: #f5f7fa; overflow: initial"
        >
          <b-row>

            <b-col sm="3" class="my-1">
              <b-form-group label="" class="mb-0">
                <el-date-picker
                  size="medium"
                  v-model="month"
                  :picker-options="{
                    disabledDate: (time) => disabledDate(time),
                  }"
                  type="month"
                  placeholder="Month"
                >
                </el-date-picker>
              </b-form-group>
            </b-col>
            <b-col sm="3" lg="2" class="my-1">
              <b-form-group label="" class="mb-0">
                <b-form-select

                  placeholder="Store Location"
                  v-model="storeLocation"
                  :options="stores"
                  @change="changeStore()"
                ></b-form-select>
              </b-form-group>
            </b-col>
            <b-col v-if="$route.name === 'jobNotes'" sm="3" lg="2" class="my-1">
              <b-form-group label="" class="mb-0">
                <b-form-input
                  v-model="cashier"
                  placeholder="Technician ID"
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col sm="3" lg="2" class="my-1">
              <b-form-group label="" class="mb-0">
                <b-form-input
                  v-model="jobNo"
                  :placeholder="$route.name === 'jobNotes' ? 'Job No' : 'Order No'"
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col sm="3" lg="2" class="my-1">
              <b-form-group label="" class="mb-0">
                <b-form-input
                  v-model="customer"
                  placeholder="Customer's Mobile No"
                ></b-form-input>
              </b-form-group>
            </b-col>
            <!-- <b-col sm="3" class="my-1">
              <b-form-group label="" class="mb-0">
                <b-form-select
                  v-model="cashier"
                  :options="options2"
                ></b-form-select>
              </b-form-group>
            </b-col> -->
          </b-row>
          <b-row>
            <b-col sm="12" class="my-1">
              <b-form-group label="" class="mb-0">
                <el-button
                  style="display: block; margin: 0 auto; margin-top: 10px"
                  type="primary"
                  size="medium"
                  @click="searchJobs"
                  >Search</el-button
                >
              </b-form-group>
            </b-col>
          </b-row>
        </el-card>

        <jobPrint style="display: none" id="jobPrint" />

        <!-- Main table element -->
        <el-card style="overflow-x: scroll;" shadow="always">
          <b-table
            show-empty
            stacked="sm"
            :items="items"
            :fields="fields"
            :hover="true"
            head-variant="dark"
            :current-page="currentPage"
            :per-page="perPage"
            :empty-text="emptyText"
            :filter="filter"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            @filtered="onFiltered"
            class="mt-4"
          >
            <template slot="index" slot-scope="data">
              {{ data.index + 1 }}
            </template>

            <template slot="status" slot-scope="row">
              <el-select
                v-model="row.item.status"
                @change="upOrder(row.item.id, row.item.status)"
                size="mini"
                style="width: 160px"
                placeholder="Order Status"
              >
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </template>

            <template slot="actions" slot-scope="row">
              <div class="btn-group" role="group" aria-label="Basic example">
                <!-- We use @click.stop here to prevent a 'row-clicked' event from also happening -->

                <a
                  size="sm"
                  @click.stop="row.toggleDetails"
                  class="btn btn-sm btn-info text-white"
                >
                  View Items
                </a>
                <a
                  size="sm"
                  @click.stop="showUpdatejob(row.item)"
                  class="btn btn-sm btn-primary text-white"
                >
                  Update
                </a>
                <router-link
                  :to="{
                    name: 'createinvoice',
                    query: { job: row.item.jobNo, },
                  }"
                  class="btn btn-sm btn-warning text-white"
                >
                  Invoice
                </router-link>
                <a
                  size="sm"
                  @click="open(row.item.id, row.item.status)"
                  class="btn btn-sm btn-danger text-white"
                >
                  Delete
                </a>
                <!-- <a
                  v-if="$store.state.systemUser.role !== 'Kitchen Staff'"
                  size="sm"
                  @click="managePrint( row.item, 'both')"
                  class="btn btn-sm btn-secondary text-white"
                >
                  Print
                </a> -->
                <a
                  size="sm"
                  @click="() => {
                    const data = { job: row.item, store: storeDetails, name: $route.name }
                    return $root.$emit('jobPrint', data)
                  }"
                  class="btn btn-sm btn-secondary text-white"
                >
                  Print
                </a>
              </div>
            </template>

            <template slot="row-details" slot-scope="row">
              <b-card>
                <ul>
                  <!-- <li v-for="(value, key) in row.item" :key="key">{{ key }}: {{ value}}</li> -->
                  <!-- <template class="" v-for="(item, key) in row.item" >
              <div :key="key"> -->
                  <!-- <h5 class="text-center text-info">Customer Details</h5>
                  <li class="my-1 mr-2">
                    Customer Name:
                    <span class="ml-2">{{ row.item.cusname }}</span>
                  </li>
                  <li class="my-1 mr-2">
                    Email: <span class="ml-2">{{ row.item.cusemail }}</span>
                  </li>
                  <li class="my-1 mr-2">
                    Telephone: <span class="ml-2">0{{ row.item.telno }}</span>
                  </li>
                  <li class="my-1 mr-2">
                    Address: <span class="ml-2">{{ row.item.address }}</span>
                  </li>
                  <li class="my-1 mr-2">
                    Cart Total Rs:
                    <span class="ml-2">{{ row.item.total }}</span>
                  </li> -->
                  <!-- </div>
            </template> -->
                </ul>
                <div> <span>Note: </span> {{row.item.note}}</div>
                <h5 class=" text-info my-4">Required Items</h5>
                <div class="row">
                  <template class="">
                    <div class="col-12 col-md-8 " style="">
                      <!-- <img class="card-img-top" :src="item.image" alt="image" /> -->
                        <el-table ref="singleTable" :data="row.item.items" highlight-current-row style="
                            {
                              overflow-x: scroll;
                              width: 800px;
                              margin: 0 auto;
                            }
                          ">
                        <el-table-column type="index" width="50"> </el-table-column>

                        <el-table-column width="250" property="serial" label="Item">
                          <template slot-scope="scope">
                            {{ scope.row.item }}
                          </template>
                        </el-table-column>
                        <el-table-column width="150" property="quantity" label="Quantity">
                          <template slot-scope="scope">
                            {{ scope.row.quantity }}
                          </template>
                        </el-table-column>

                      </el-table>

                    </div>
                  </template>
                </div>
              </b-card>
            </template>
          </b-table>
        </el-card>

         <b-col sm="3" class="my-1">
            <b-form-group class="mb-0">
              <b-form-select v-model="perPage">
                <option disabled>per page</option>
                <option :value="10">10</option>
                <option :value="20">20</option>
                <option :value="40">40</option>
              </b-form-select>
            </b-form-group>
          </b-col>
          <b-col md="6" class="my-1">
          <b-pagination
            :total-rows="totalRows"
            :per-page="perPage"
            v-model="currentPage"
            class="my-0"
          />
        </b-col>
        <!-- Info modal -->
        <!-- <b-modal id="modalInfo" @hide="resetModal" :title="modalInfo.title" ok-only>
      <pre>{{ modalInfo.content }}</pre>
       <AddProduct/>
    </b-modal> -->
      </b-container>
    </div>
  </div>
</template>

<script>
import db from "../../config/FirebaseInit";
import firebase from "firebase/app";
import JobNoteDialog from './JobNoteDialog.vue'
import JobPrint from './InvoiceTemplates/JobPrint.vue'
import { bus } from "../../main";
const items = [];
export default {
  name: "job",
   components: {
    JobNoteDialog,
    JobPrint
  },
  data() {
    return {
      BUS: bus,
      emptyText: "Loading Records...",
      items: [],
      fields: [
        "index",
        //  { key: 'id', label: 'Order id', sortable: true },
        { key: "jobNo", label: this.$route.name === 'jobNotes' ? "job No" : 'Order No', sortable: true },
        { key: "date", label: "Date", sortable: true },
        { key: "name", label: "Customer", sortable: true },
        { key: "tel", label: "Telephone", sortable: true },
        this.$route.name === 'jobNotes' ? { key: "device", label: "Device", sortable: true } : "",
        this.$route.name === 'jobNotes' ? { key: "techName", label: "Technician", sortable: true } : '',
        { key: "adv", label: "Advance(Rs)", sortable: true },
        { key: "status", label: "Status", sortable: true },
        { key: "invoice", label: "Invoice No", sortable: true },
        { key: "actions", label: "Actions" },
      ],
      options: [
        {
          value: "Pending",
          label: "Pending",
        },
        {
          value: "Working",
          label: "Working",
        },
        {
          value: "Completed",
          label: "Completed",
        },
      ],
      serviceStaffOptions: [
        {
          value: "Served",
          label: "Served",
        },
        {
          value: "Cancelled",
          label: "Cancelled",
        },
      ],
      stores: this.$store.state.stores,// [{ value: null, text: "Select Store Location", disabled: true }],
      storeLocation: this.$store.state.selectedStore,
      month: new Date(),
      jobNo: "",
      customer: "",
      cashier: null,
      productId: "",
      currentPage: 1,
      perPage: 10,
      totalRows: items.length,
      pageOptions: ["Per Page", 5, 10, 15],
      sortBy: null,
      sortDesc: false,
      filter: null,
      isLoggedIn: false,
      currentUser: false,
      modalInfo: { title: "", content: "" },
      loading: false,
      loading1: false,
      loading2: false,
      changed: false,
      shops: [],
      orders: "",
      dialogFormVisible2:false,
      dialogFormVisible:false,
      jobItems: [],
      tableNo:'',
      width: '',
      jobNote: "",
      job: {},
      printjob: '',
      printBot: '',
      allProducts: [],
      users: [],
      storeDetails: {}
    };
  },

  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => {
          return { text: f.label, value: f.key };
        });
    },
  },
  mounted() {
    this.storeDetails = this.stores.find(str => str.id === this.storeLocation)
    console.log('storeDetails',this.storeDetails)
    const saveType = this.$route.name === 'jobNotes' ? 'jobSaved' : 'orderSaved'
    bus.$on(saveType, (data) => {
      this.dialogFormVisible2 = false;
     this.dialogFormVisible = false;
     console.log('data',data,saveType)
     data.date && typeof data.date !== 'string' ? data.date = data.date.toDate().toLocaleString() : ''
     data.date ? this.items.unshift(data) : ''
    })

  },
  methods: {
    showUpdatejob(item) {
      console.log("job",item)
      this.job = item;
      this.dialogFormVisible = true;
    },
    open(id, status) {
      this.$confirm(
        "This will permanently delete the item. Continue?",
        "Warning",
        {
          confirmButtonText: "OK",
          cancelButtonText: "Cancel",
          type: "warning",
          center: true,
        }
      )
        .then(() => {
          if (status === "Pending" || status === "Working") {
            return this.$notify({
              title: "Cannot Delete",
              message: "Job status is pending or working",
              duration: 0,
              type: "error",
            });
          }
          this.deleteOrder(id, status);
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "Delete canceled",
          });
        });
    },
    // open2(id) {
    //   this.$confirm('This will change the order status. Continue?', 'Warning', {
    //     confirmButtonText: 'OK',
    //     cancelButtonText: 'Cancel',
    //     type: 'warning',
    //     center: true
    //   }).then(() => {
    //     this.upOrder(id)
    //   }).catch(() => {
    //     this.$message({
    //       type: 'info',
    //       message: 'Change canceled'
    //     });
    //   });
    // },
    open3() {
      this.$notify.info({
        title: "Success",
        type: "success",
        message: "job status is updated",
      });
    },
    upOrder(id, status, refid) {
      this.$store.state.secondaryDatabase
        .collection("job")
        .doc(id)
        .update({
          status: status,
        })
        .then(() => {
          this.open3();

        })
        .catch((error) => alert(error));
    },
    deleteOrder(id, status) {
      this.loading2 = true;
      this.changed = false;
      this.$store.state.secondaryDatabase
        .collection("job")
        .doc(id)
        .delete()
        .then(() => {
          //console.log('item deleted', id)
          var newitems = this.items.filter((item) => {
            //console.log('filfkkk')
            return item.id !== id;
          });
          this.items = newitems;
          this.totalRows = this.items.length;
          this.loading2 = false;
          this.changed = true;
          if (this.items.length == 0) {
            this.emptyText = "There are no records to show";
          }
          //console.log(this.items)

        })
        .catch((error) => alert(error));
    },

    info(item, index, button) {
      this.modalInfo.title = `Row index: ${index}`;
      this.modalInfo.content = JSON.stringify(item, null, 2);
      this.$root.$emit("bv::show::modal", "modalInfo", button);
    },
    resetModal() {
      this.modalInfo.title = "";
      this.modalInfo.content = "";
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    getId(item) {
      //console.log('getId fun invoked')
      this.productId = item.id;
      //console.log(this.productId)
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    backToTop: function () {
      $("html,body").stop().animate(
        {
          scrollTop: 0,
        },
        "fast",
        "swing"
      );
    },

    searchJobs() {
      if (
        !this.month &&
        this.customer === "" &&
        this.jobNo === "" &&
        !this.cashier
      ) {
        return alert("Please select month");
      }
      if (
        !this.storeLocation &&
        this.customer === "" &&
        this.jobNo === ""
      ) {
        return alert("Please select store location");
      }
      this.loading = true;
      this.changed = false;
      this.items = [];
      console.log(
        "values",
        this.month,
        this.storeLocation,
        this.invoiceNo,
        this.customer
      );
      const docRef = this.$store.state.secondaryDatabase.collection("job");
      let firestoreQuery = docRef;
      const type = this.$route.name === 'jobNotes' ? 'job' : 'order'
      firestoreQuery = firestoreQuery.where("type", "==", type);
      if (this.month) {
        const date = new Date(this.month);
        const firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
        const lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 1);
        // console.log("dates", firstDay, lastDay);
        firestoreQuery = firestoreQuery.where(
          "date",
          ">=",
          firebase.firestore.Timestamp.fromDate(firstDay)
        );
        firestoreQuery = firestoreQuery.where(
          "date",
          "<=",
          firebase.firestore.Timestamp.fromDate(lastDay)
        );
      }
      if (this.storeLocation) {
        firestoreQuery = firestoreQuery.where(
          "store",
          "==",
          this.storeLocation
        );
      }
      if (this.jobNo) {
        firestoreQuery = firestoreQuery.where(
          "jobNo",
          "==",
          this.jobNo
        );
      }
      if (this.cashier) {
        firestoreQuery = firestoreQuery.where("techId", "==", this.cashier);
      }
      if (this.customer) {
        firestoreQuery = firestoreQuery.where(
          "tel",
          "==",
          +this.customer
        );
      }
      // console.log('query',firestoreQuery)
      firestoreQuery
        .orderBy("date", "desc")
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            const data = {
              id: doc.id,
              items: doc.data().items,
              date: doc.data().date.toDate().toLocaleString(),
              jobNo: doc.data().jobNo,
              store: doc.data().store,
              techId: doc.data().techId,
               techName: doc.data().techName,
              user: doc.data().user,
              name: doc.data().name,
              tel: doc.data().tel,
              adv: doc.data().adv,
              status: doc.data().status,
              invoice: doc.data().invoice || 'Not invoiced',
              device: doc.data().device,
              updated: doc.data().updated.toDate().toLocaleString(),
              updatedBy: doc.data().updatedBy,
               note: doc.data().note,
              _showDetails: false // toggle row details
            };

            this.items.push(data);
            this.totalRows = this.items.length;
          });
          if (this.items.length == 0) {
            this.emptyText = "There are no records to show";
          }
          this.loading = false;
          this.changed = true;
        });
    },
  },
  created() {
    if (screen.width > 767) {
      this.width = "50%";
    } else {
      this.width = "85%";
    }
    //  if(firebase.auth().currentUser) {
    //       this.isLoggedIn = true;
    //       this.currentUser = firebase.auth().currentUser.email;
    //   }
    //  db.collection('shops').where('owner', '==', firebase.auth().currentUser.uid).get()
    //   .then(querySnapshot => {
    //   querySnapshot.forEach(doc => {
    //     const data = {
    //       'id': doc.id,
    //     }
    //     this.shops.push(data)
    //   })
    this.backToTop();
    this.loading = true;
    this.changed = false;
    this.searchJobs()

    if (this.$store.state.users.length != 0) {
      this.users = this.$store.state.users;
    } else {
      const docRef = this.$store.state.secondaryDatabase.collection("sysusers");
      let firestoreQuery = docRef;
      if(this.$store.state.noDB === true) {
        firestoreQuery = firestoreQuery.where("shopOwner", "==", firebase.auth().currentUser.uid)
      }
      firestoreQuery
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            const data = {
              id: doc.id,
              name: doc.data().name,
              email: doc.data().email,
              city: doc.data().city,
              regdate: doc.data().regdate,
              telephone: doc.data().telephone,
              sysid: doc.data().sysid,
              role: doc.data().role,
              store: doc.data().store,
              note: doc.data().note,
              permissions: doc.data().permissions,
            };
            if (data.regdate != undefined) {
              data.regdate = doc.data().regdate.toDate().toLocaleString();
            }
            this.users.push(data);
            this.$store.state.users = this.users;
          });


        });
    }

    if (this.$store.state.allProducts != undefined && this.$store.state.allProducts.length !== 0) {
      this.allProducts = this.$store.state.allProducts;
    } else if (this.$store.state.allProducts.length === 0) {
      this.$store.state.secondaryDatabase
        .collection("products")
        .where("owner", "==", firebase.auth().currentUser.uid)
        .get()
        .then((querySnapshot) => {
          var newitems = [];
          querySnapshot.forEach((doc) => {
            // //console.log('this.items.length is', state.items.length)
            const data = {
              id: doc.id,
              name: doc.data().name,
              barcode: doc.data().barcode,
              altertQunty: doc.data().altertQunty,
              category: doc.data().cat,
              brand: doc.data().brand,
              price: doc.data().disprice,
              subcategory: doc.data().subcat,
              desc: doc.data().desc,
              priceList: doc.data().priceList,
              totalQnty: 0,
              rack: doc.data().rack || '',
              img: doc.data().img,
              // 'otherimgs': doc.data().otherimgs,
            };
            // const bytes = sizeof(doc.data());
            // console.log("size of doc", bytes, doc.data().name);
            newitems.push(data);
            this.allProducts = newitems;
            this.$store.state.allProducts = newitems;

          });

          this.loading1 = false;
          this.changed = true;
          console.log('job', newitems)
          //console.log('state.items',this.$store.state.items)
        });
    }

    // })
  },
};
</script>

<style scoped>
@import url("~@/assets/admin/css/admin-loader.css");
</style>




// WEBPACK FOOTER //
// src/components/admin/JobNotes.vue